/* „Podobne ćwiczenia" — KANON `Cwiczenia` 17.09.2026, `2-karta.html#e`'s `simRow()`.
 *
 * Four cards under the hero, headed by the title and the hint that says where the list came from. The strip is `flex: none` over a fixed reserve: the hero above it is `flex: 1` against
 * the same column, so a strip that grew when its read landed would shrink the picture. Its skeleton
 * stands inside that reserve rather than replacing it.
 *
 * Every text leaf states its line-height; every figure is tabular. */

.strip {
  display: flex;
  flex: none;
  flex-direction: column;
  height: var(--h-ex-theatre-similar);
  margin-top: var(--space-5);
}

.head {
  display: flex;
  flex: none;
  gap: var(--space-3);
  align-items: center;

  /* 8, not the 10 the other block heads use: measured off `kanon-02-teatr-light.png`. */
  margin-bottom: var(--space-2);
}

.title {
  margin: var(--space-0);
  font-size: var(--fs-body);
  font-weight: var(--fw-bold);
  line-height: var(--lh-display);
  letter-spacing: var(--ls-heading);
  color: var(--text);
}

.hint {
  font-size: var(--fs-micro);
  font-weight: var(--fw-medium);
  line-height: var(--lh-display);
  color: var(--text-3);
}

/* Four equal tracks. `minmax(0, 1fr)` and not `1fr`: a grid track's default minimum is its content,
 * so a long movement name would push the fourth card off the column's right edge. */
.cards {
  display: grid;
  flex: 1;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--space-3);
  min-height: 0;
}

.card {
  display: block;
  padding: var(--space-0);
  font: inherit;
  text-align: left;
  cursor: pointer;
  background: none;
  border: none;
}

.card:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

/* GEOMETRY only — the frame's treatment is `exerciseStill.module.css`'s. 16:11, as the specimen
 * draws it in this variant, rather than the 16:10 the other cards use. */
.still {
  width: 100%;
  aspect-ratio: 16 / 11;
  border-radius: var(--radius-8px);
}

/* Two lines at most, clamped, so a long name cannot make the fourth card taller than the first and
 * push the strip past its reserve. */
.name {
  display: -webkit-box;
  margin: var(--space-7px) var(--space-0) var(--space-0);
  overflow: hidden;
  font-size: var(--fs-note);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-name);
  color: var(--text);
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.card:hover .name {
  text-decoration: underline;
}

/* The two absences. One line, inside the same reserve, so nothing moves between the three states. */
.absence {
  margin: var(--space-0);
  font-size: var(--fs-micro);
  font-weight: var(--fw-medium);
  line-height: var(--lh-normal);
  color: var(--text-3);
}

/* ── The wait ───────────────────────────────────────────────────────────────────────────────── */

.skelStill {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 11;
}

.skelName {
  display: block;
  width: 72%;
  height: 11px;
  margin-top: var(--space-7px);
}
